import React, { useState, useEffect, useCallback } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';

const reviews = [
  {
    name: 'Ganga Rai Jones',
    date: 'Dec 2025',
    text: 'We would like to thank Stephen and Jeng so much for their assistance and support in our refinancing process. The team were proactive and always available to help.',
  },
  {
    name: 'Pooja Naidu',
    date: 'Nov 2025',
    text: "Stephen's professionalism, attention to detail, and genuine care made the entire mortgage process smooth and stress-free. He secured us the best rates when our first bank delayed.",
  },
  {
    name: 'Nigel Taylor',
    date: 'Nov 2025',
    text: 'Damien and Jeng were amazing to deal with! They helped us refinance our home loan so we could get our renovations underway. The process was easy and stress-free.',
  },
  {
    name: 'Jenny Searle',
    date: 'Nov 2025',
    text: 'Damien was efficient and friendly. In a blink of an eye he got me from point A to B.',
  },
  {
    name: 'Tozano',
    date: 'Oct 2025',
    text: 'Damien was very helpful, easy to communicate with. Kept me informed all the way and successfully refinanced my mortgage with a much better deal.',
  },
  {
    name: 'Scott Giffen',
    date: 'Sep 2025',
    text: 'Stephen and his team are highly recommended; my SMSF lending case was a complex one, but Stephen found some options. Great communication and responsiveness throughout.',
  },
  {
    name: 'Matthew Campton',
    date: 'Sep 2025',
    text: 'Damien from Manage Your Loans was fantastic in every step of our refinancing. Always available on the phone whenever questions needed to be answered.',
  },
  {
    name: 'Suraj Subramani Vineet',
    date: 'Sep 2025',
    text: "We were very impressed with the support we received during our home loan process. Damien's expertise and professionalism stood out.",
  },
  {
    name: 'Manda H',
    date: 'Aug 2025',
    text: 'Stephen was great throughout the whole process. He kept me up-to-date and informed the entire time.',
  },
  {
    name: 'Brendan Smith',
    date: 'Jun 2025',
    text: 'Stephen Vider from Manage Your Loans helped me greatly through the refinance process. He was very transparent throughout.',
  },
  {
    name: 'Pourya Pazandeh',
    date: 'May 2025',
    text: 'Ben was absolutely friendly and made the entire refinancing process completely stress-free for us. He took the time to understand our needs.',
  },
  {
    name: 'Michael L',
    date: 'Mar 2025',
    text: 'We gave Damien from Manage Your Loans a complex challenge as we were refinancing 3 separate mortgages on two properties. He completed the intricate case successfully.',
  },
  {
    name: 'Thomson Tam',
    date: 'Oct 2024',
    text: 'Great service, MYL managed to get a better deal from the same bank! A must go for your home loan.',
  },
  {
    name: 'Marco Loprevite',
    date: 'Sep 2024',
    text: 'Damien was a pleasure to deal with. Walked me through the whole process. Made everything very simple.',
  },
  {
    name: 'NikoD',
    date: 'Aug 2024',
    text: "We wish to acknowledge the outstanding service we experienced throughout the refinancing process. Damien's professionalism and industry knowledge were remarkable.",
  },
  {
    name: 'Michael Howard',
    date: 'Jul 2024',
    text: 'Amazing! Debra and the team took exceptional care of us while getting a home loan for our first home in Australia.',
  },
  {
    name: 'Grant Maskell',
    date: 'Jul 2024',
    text: 'Second time around with Damien. Highly recommend him for his honesty, integrity and personalised service.',
  },
  {
    name: 'Alvin Garcia',
    date: 'May 2024',
    text: 'The team from Manage Your Loans has been really helpful in doing my refinance to another lender. Thank you Deb, Grace and Leanne.',
  },
  {
    name: 'Sandeep Kappala Venkat',
    date: 'May 2024',
    text: 'Damien was fantastic as our mortgage broker! From start to finish, he was knowledgeable, professional, and incredibly helpful.',
  },
  {
    name: 'Janice Elsley',
    date: 'Feb 2024',
    text: 'The team at Manage Your Loans were amazing. Leanne and Nathan were with me every step of the way and successfully got over the line a new loan for my Self Managed Super Fund.',
  },
];

const CARDS_PER_VIEW = { mobile: 1, tablet: 2, desktop: 3 };

const GoogleLogo = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);

const getInitials = (name) =>
  name.split(' ').map((n) => n[0]).join('').toUpperCase().slice(0, 2);

const getColor = (name) => {
  const colors = [
    'bg-blue-500', 'bg-emerald-500', 'bg-violet-500', 'bg-amber-500',
    'bg-rose-500', 'bg-cyan-500', 'bg-indigo-500', 'bg-teal-500',
    'bg-pink-500', 'bg-lime-500',
  ];
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return colors[Math.abs(hash) % colors.length];
};

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardsPerView, setCardsPerView] = useState(CARDS_PER_VIEW.desktop);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const maxIndex = reviews.length - cardsPerView;

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) setCardsPerView(CARDS_PER_VIEW.mobile);
      else if (window.innerWidth < 1024) setCardsPerView(CARDS_PER_VIEW.tablet);
      else setCardsPerView(CARDS_PER_VIEW.desktop);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const next = useCallback(() => {
    setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  }, [maxIndex]);

  const prev = () => {
    setCurrentIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };

  useEffect(() => {
    if (!isAutoPlaying) return;
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [isAutoPlaying, next]);

  return (
    <section className="py-20 bg-gradient-to-br from-[#00594C] to-[#003d35] text-white" data-testid="testimonials-section">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center space-x-2 bg-white/10 backdrop-blur-md px-6 py-2 rounded-full mb-6 border border-white/20">
            <Star className="w-5 h-5 text-[#99DF63] fill-[#99DF63]" />
            <span className="text-white font-semibold">Google Reviews</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">What Our Clients Say</h2>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Real reviews from real clients across Australia
          </p>
        </div>

        {/* Carousel */}
        <div
          className="relative"
          onMouseEnter={() => setIsAutoPlaying(false)}
          onMouseLeave={() => setIsAutoPlaying(true)}
        >
          <button
            onClick={prev}
            className="absolute -left-2 md:-left-6 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white/10 backdrop-blur-md rounded-full flex items-center justify-center border border-white/20 hover:bg-white/20 transition-all"
            aria-label="Previous reviews"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            onClick={next}
            className="absolute -right-2 md:-right-6 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white/10 backdrop-blur-md rounded-full flex items-center justify-center border border-white/20 hover:bg-white/20 transition-all"
            aria-label="Next reviews"
          >
            <ChevronRight className="w-5 h-5" />
          </button>

          <div className="overflow-hidden mx-6 md:mx-8">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentIndex * (100 / cardsPerView)}%)` }}
            >
              {reviews.map((review, index) => (
                <div
                  key={index}
                  className="flex-shrink-0 px-3"
                  style={{ width: `${100 / cardsPerView}%` }}
                >
                  <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 h-full flex flex-col">
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center space-x-1">
                        {[...Array(5)].map((_, i) => (
                          <Star key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" />
                        ))}
                      </div>
                      <GoogleLogo className="w-5 h-5 opacity-60" />
                    </div>

                    <p className="text-gray-100 text-sm leading-relaxed flex-grow mb-5">
                      "{review.text}"
                    </p>

                    <div className="flex items-center space-x-3 mt-auto pt-4 border-t border-white/10">
                      <div className={`w-10 h-10 ${getColor(review.name)} rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0`}>
                        {getInitials(review.name)}
                      </div>
                      <div className="min-w-0">
                        <div className="font-semibold text-white text-sm truncate">{review.name}</div>
                        <div className="text-xs text-gray-400">{review.date}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Dots */}
        <div className="flex justify-center mt-8 space-x-2">
          {Array.from({ length: Math.ceil(reviews.length / cardsPerView) }).map((_, i) => {
            const dotIndex = i * cardsPerView;
            const isActive = currentIndex >= dotIndex && currentIndex < dotIndex + cardsPerView;
            return (
              <button
                key={i}
                onClick={() => setCurrentIndex(Math.min(dotIndex, maxIndex))}
                className={`h-2 rounded-full transition-all ${isActive ? 'bg-[#99DF63] w-6' : 'bg-white/30 w-2'}`}
                aria-label={`Go to review group ${i + 1}`}
              />
            );
          })}
        </div>

        {/* Google Rating Badge */}
        <div className="mt-10 text-center">
          <div className="inline-flex items-center space-x-4 bg-white/10 backdrop-blur-md px-8 py-4 rounded-full border border-white/20">
            <GoogleLogo className="w-8 h-8" />
            <div className="text-left">
              <div className="flex items-center space-x-2">
                <span className="text-3xl font-bold">5.0</span>
                <div className="flex items-center space-x-0.5">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" />
                  ))}
                </div>
              </div>
              <div className="text-sm text-gray-300">Based on 21 Google Reviews</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
